import { IIconProps } from "../types"

export default function IconUL5(props: IIconProps) {
  const width = props.size || props.width || 64
  const height = props.size || props.height || 80
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 64 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.7758 1.1871C36.0958 0.507101 32.4558 0.567101 29.2658 1.7471C26.0758 2.9171 23.3358 5.1971 20.6058 8.6171C17.8658 12.0271 15.1358 16.5871 12.2358 21.5971C9.33578 26.6171 6.28578 32.0871 4.33578 36.4771C2.38578 40.8671 1.53578 44.1871 1.08578 47.4771C0.625782 50.7671 0.555782 54.0271 1.40578 57.2771C2.24578 60.5371 4.00578 63.7871 5.98578 66.5171C7.97578 69.2571 10.1858 71.4671 13.2458 73.6471C16.3058 75.8371 20.2158 77.9771 24.6058 78.7571C29.0058 79.5471 33.8858 78.9571 38.0858 78.2371C42.2858 77.5271 45.7958 76.6771 48.5958 75.0171C51.3958 73.3571 53.4858 70.8871 55.7958 67.9271C58.1058 64.9571 60.6458 61.5071 61.9558 57.5671C63.2758 53.6271 63.3658 49.2071 63.0958 44.1271C62.8458 39.0471 62.2258 33.3171 61.3758 28.1471C60.5158 22.9671 59.4058 18.3471 57.6158 14.5371C55.8258 10.7271 53.3558 7.7371 50.2558 5.5171C47.1658 3.3071 43.4558 1.8771 39.7758 1.1871Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
